import React from 'react';
import { Video, Mic, Target, Megaphone, TrendingUp, Users } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Video,
      title: 'Video Production',
      description: 'Professional product videos, promotional content, and brand storytelling that captivates your audience.',
      image: 'https://images.unsplash.com/photo-1632187989763-c9c620420b4d'
    },
    {
      icon: Megaphone,
      title: 'Social Media Advertising',
      description: 'Expert Instagram, Facebook, and YouTube ad campaigns through Meta Ads Manager for maximum reach.',
      image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc3NTQwODEzM3ww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Target,
      title: 'Google AdWords',
      description: 'Strategic search and display campaigns that put your business in front of customers actively searching for your services.',
      image: 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjB0ZWFtfGVufDB8fHx8MTc3NTQ1NzE4MXww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Mic,
      title: 'Podcast Production',
      description: 'Complete podcast setup, recording, editing, and distribution to establish your authority in your industry.',
      image: 'https://images.unsplash.com/photo-1668606143326-4d53db523e00'
    },
    {
      icon: TrendingUp,
      title: 'Lead Generation',
      description: 'Data-driven strategies to attract, engage, and convert high-quality leads for your business.',
      image: 'https://images.pexels.com/photos/11329815/pexels-photo-11329815.jpeg'
    },
    {
      icon: Users,
      title: 'Brand Strategy',
      description: 'Comprehensive digital marketing strategies tailored to your profession and target audience.',
      image: 'https://images.pexels.com/photos/33231527/pexels-photo-33231527.jpeg'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">What We Offer</span>
          <h2 className="mt-2 text-4xl lg:text-5xl font-bold text-gray-900" style={{ fontFamily: 'var(--font-serif)' }}>
            Comprehensive Digital Marketing Services
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            From concept to execution, we deliver end-to-end digital marketing solutions that drive real results.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                {/* Service Image */}
                <div className="relative h-48 overflow-hidden bg-gray-100">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-black" />
                    </div>
                  </div>
                </div>

                {/* Service Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'var(--font-serif)' }}>
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
